import VeeValidate, {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

export default {
  expose(Vue) {
    Vue.use(VeeValidate, {
      inject: true,
    });

    // Install components
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.component('ValidationObserver', ValidationObserver);
  },
};
